module.exports = __webpack_public_path__ + "img/logo.f0914b01.png";